import React, { memo } from 'react';

import { VideoContainer } from './styles';

const Video = memo(({ src, ...rest }) => {
  return <VideoContainer />;
});

export default Video;
